import admitadImg from './imgs/componies/admitad.png';
import adv_cakeImg from './imgs/componies/adv_cake.png';
import alfaImg from './imgs/componies/alfa.png';
import alfastrahImg from './imgs/componies/alfa_strah.png';
import cbImg from './imgs/componies/cb.png';
import cityadsImg from './imgs/componies/cityads.png';
import geliosImg from './imgs/componies/gelios.png';
import ingostrahImg from './imgs/componies/ingostrah.png';
import intouchImg from './imgs/componies/intouch.png';
import leadgidImg from './imgs/componies/leadgid.png';
import leadsImg from './imgs/componies/leads.png';
import maksImg from './imgs/componies/maks.png';
import mts_bankImg from './imgs/componies/mts_bank.png';
import oscImg from './imgs/componies/osc.png';
import otkritieImg from './imgs/componies/otkritie.png';
import psbImg from './imgs/componies/psb.png';
import raifaizen_bankImg from './imgs/componies/raiffasen_bank.png';
import renessansImg from './imgs/componies/renessans.png';
import rosgosstrahImg from './imgs/componies/rosgosstrah.png';
import sberImg from './imgs/componies/sber.png';
import sber_strahImg from './imgs/componies/sber_strah.png';
import sogazImg from './imgs/componies/sogaz.png';
import soglasieImg from './imgs/componies/soglasie.png';
import sovkombank_strahImg from './imgs/componies/sovkombank_strah.png';
import tinkoffImg from './imgs/componies/tinkoff.png';
import tochkaImg from './imgs/componies/tochka.png';
import travelpayoutsImg from './imgs/componies/travelpayouts.png';
import uralsibImg from './imgs/componies/uralsib.png';
import uralsib_bankImg from './imgs/componies/uralsib_bank.png';
import vskImg from './imgs/componies/vsk.png';
import vtbImg from './imgs/componies/vtb.png';
import yugoriyaImg from './imgs/componies/yugoriya.png';
import zettaImg from './imgs/componies/zetta.png';

export const MARQUEE_IMGS = [
  { ...admitadImg, alt: 'admitad' },
  { ...adv_cakeImg, alt: 'adv_cake' },
  { ...alfaImg, alt: 'alfa' },
  { ...alfastrahImg, alt: 'alfastrah' },
  { ...cbImg, alt: 'cb' },
  { ...cityadsImg, alt: 'cityads' },
  { ...geliosImg, alt: 'gelios' },
  { ...ingostrahImg, alt: 'ingostrah' },
  { ...intouchImg, alt: 'intouch' },
  { ...leadgidImg, alt: 'leadgid' },
  { ...leadsImg, alt: 'leads' },
  { ...maksImg, alt: 'maks' },
  { ...mts_bankImg, alt: 'mts_bank' },
  { ...oscImg, alt: 'osc' },
  { ...otkritieImg, alt: 'otkritie' },
  { ...psbImg, alt: 'psb' },
  { ...raifaizen_bankImg, alt: 'raifaizen_bank' },
  { ...renessansImg, alt: 'renessans' },
  { ...rosgosstrahImg, alt: 'rosgosstrah' },
  { ...sberImg, alt: 'sber' },
  { ...sber_strahImg, alt: 'sber_strah' },
  { ...sogazImg, alt: 'sogaz' },
  { ...soglasieImg, alt: 'soglasie' },
  { ...sovkombank_strahImg, alt: 'sovkombank_strah' },
  { ...tinkoffImg, alt: 'tinkoff' },
  { ...tochkaImg, alt: 'tochka' },
  { ...travelpayoutsImg, alt: 'travelpayouts' },
  { ...uralsibImg, alt: 'uralsib' },
  { ...uralsib_bankImg, alt: 'uralsib_bank' },
  { ...vskImg, alt: 'vsk' },
  { ...vtbImg, alt: 'vtb' },
  { ...yugoriyaImg, alt: 'yugoriya' },
  { ...zettaImg, alt: 'zetta' },
];
